import React, { useEffect, useState } from 'react'
import { sendTeaCommEvent } from 'lib/tea-analyze'
import { friendshipLinkData as getFriendshipLinkData } from '../../services/home'

interface IFriendshipLink {
  friendshipLinkData: IFriendshipLinkData[]
}

export interface IFriendshipLinkData {
  name: string
  link: string
}

function FriendshipLink() {
  const [friendshipLinkData, setFriendshipLinkData] = useState<IFriendshipLinkData[]>([]!);

  useEffect(() => {
    const init = async () => {
      try {
        const list = await getFriendshipLinkData(null)
        setFriendshipLinkData(list);
      }
      catch(e) {

      }
    }
    init();
  }, [])

  if (!friendshipLinkData || !friendshipLinkData.length) return null
  return (
    <div className="container">
      <div className="content">
        {friendshipLinkData?.map((friendshipLink: IFriendshipLinkData) => {
          return (
            <a
              className="link-item"
              href={friendshipLink.link}
              key={friendshipLink.name}
              rel="noopener noreferrer"
              target="_blank"
              onClick={() => {
                sendTeaCommEvent('clk_event', {
                  page_id: 'page_main_new',
                  event_id: 'related_module_company_link',
                  module_id: 'related_module',
                  button_name: friendshipLink.name
                })
              }}
            >
              {friendshipLink.name}
            </a>
          )
        })}
      </div>
      <style jsx>
        {`
          .container {
            padding-bottom: 4px;
          }
          .container a:hover {
            color: #e65800;
          }
          .content {
            display: flex;
            flex-wrap: wrap;
          }
          .link-item {
            color: #666666;
            margin-bottom: 8px;
            font-family: PingFangSC;
            font-size: 14px;
            font-weight: normal;
            font-stretch: normal;
            font-style: normal;
            line-height: normal;
            letter-spacing: normal;
            color: #1f2129;
            margin-right: 8px;
          }
          .link-item:hover {
            color: rgb(61, 89, 129);
          }
        `}
      </style>
    </div>
  )
}

export default FriendshipLink
